import { render, staticRenderFns } from "./headerEditModal.vue?vue&type=template&id=56fee468&"
import script from "./headerEditModal.vue?vue&type=script&lang=js&"
export * from "./headerEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports